import React from "react";
import { Avatar } from "@mui/material";
import { tokens } from "../../theme";

const AVATAR_COLORS = [
  tokens.colors.primary.main,
  tokens.colors.info.main,
  tokens.colors.success.main,
  tokens.colors.secondary.main,
  "#7367F0",
  "#FF6B6B",
];

function colorForName(name: string): string {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
}

export interface HolderAvatarProps {
  name: string;
  size?: number;
}

const HolderAvatar: React.FC<HolderAvatarProps> = ({ name, size = 40 }) => {
  const initial = name.trim().charAt(0).toUpperCase() || "?";
  return (
    <Avatar
      sx={{
        width: size,
        height: size,
        bgcolor: colorForName(name),
        fontSize: size * 0.4,
        fontWeight: 700,
      }}
    >
      {initial}
    </Avatar>
  );
};

export default HolderAvatar;
